import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  useMap,
  Marker,
  Polyline,
  Circle,
  Polygon,
  Tooltip,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { LineUtil, Util } from "leaflet";
import L from "leaflet";
import "leaflet-draw/dist/leaflet.draw.css";
import { Button, Spinner } from "reactstrap";
import { postBranchPath } from "../../../helpers/backend_helper";

function CIRCLE(lat, lng, radio) {
  return { type: "circle", lat: lat, lng: lng, radio: radio };
}

function LINESTRING() {
  let R = { type: "line", area: [] };
  let A = _.chunk(arguments, 2);
  A.forEach(function (e) {
    R.area.push({ lat: e[0], lng: e[1] });
  });
  return R;
}

function POLYGON() {
  let R = { type: "polygon", area: [] };
  let A = _.chunk(arguments, 2);
  A.forEach(function (e) {
    if (isNaN(Number(e[0]))) {
      console.log(arguments);
      throw new Exception();
    }
    if (isNaN(Number(e[1]))) {
      console.log(arguments);
      throw new Exception();
    }
    R.area.push({ lat: e[0], lng: e[1] });
  });
  return R;
}

function generateArea(e, index) {
  const areaOptions = {
    color: "#696969",
    fillColor: "#696969",
    fillOpacity: 0.3,
  };
  console.log("e.geo", e.geo);
  if(e.geo == null)
    return <></>;
  let area = eval(
    e.geo.replace("((", "(").replace("))", ")").split(" -").join(",-")
  );
  //area = eval(e.area.split(' -').join(',-'));
  console.log("area", area);
  if (area.type == "circle") {
    return (
      <Circle
        key={index}
        center={area}
        radius={area.radio}
        pathOptions={areaOptions}
      >
        <Tooltip direction="bottom" offset={[0,0]} opacity={0.7} permanent>
          {e.alias}
        </Tooltip>
      </Circle>
    );
  } else if (area.type == "line") {
    return (
      <Polyline
        key={index}
        text={e.alias}
        pathOptions={areaOptions}
        positions={area.area}
      >
        <Tooltip direction="bottom" offset={[0,0]} opacity={0.7} permanent>
          {e.alias}
        </Tooltip>
      </Polyline>
    );
  } else if (area.type == "polygon") {
    return (
      <Polygon
        key={index}
        tool={e.alias}
        pathOptions={areaOptions}
        positions={area.area}
      >
        <Tooltip direction="bottom" offset={[0,0]} opacity={0.7} permanent>
          {e.alias}
        </Tooltip>
      </Polygon>
    );
  }
}

const EditMap = ({ geofences, branch, positions, item, setBranch }) => {
  const ref = useRef();
  const mapRef = React.useRef();
  const [error, setError] = useState('');
  const [loadMap, setLoadMap] = useState(false);
  const [line, setLine] = useState(positions.map((e) => [e.lat, e.lng]));
  const [loading, setLoading] = useState(false);
  const [bounds, setBounds] = useState([
    [19.432608, -99.133209],
    [19.432608, -99.133209],
  ]);

  useEffect(() => {
    if (line.length < 2) return;
    if (!loadMap) return;
    var bounds = L.latLngBounds(line);
    console.log("fit bounds", bounds);
    mapRef.current?.fitBounds(bounds);
  }, [line, loadMap]);

  /*
  useEffect(() => {
    setLine(stops.map((e) => [e.lat, e.lng]))
  }, [branch]);
  */
  

  useEffect(() => {
    if (!item) return;

    mapRef.current?.setView([item.lat, item.lng],17);
  }, [item]);

  const save = async () => {
    if (validate()) {
      setLoading(true);
      try {
        const response = await postBranchPath(branch.id, { path: line });
        setBranch(response.branch);
        setEdit(false);
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    }
  };

  const validate = () => {
    let errorsNo = 0;
    errorsNo = line.length < 2 ? errorsNo + 1 : errorsNo;

    if (errorsNo == 0) {
      setError(null);
      return true;
    }
    setError(
      "Debe agregar almenos 1 geocerca e indicar una geocerca intermedia."
    );
    return false;
  };

  const updateLayers = (e) => {
    let newLayers = e.layers.getLayers();
    if (newLayers.length == 0) return;

    let json = ref.current?.toGeoJSON();
    ref.current?.removeLayer(ref.current?.getLayers()[0]);
    L.geoJSON(json).eachLayer(function (layer) {
      ref.current?.addLayer(layer);
    });

    console.log(
      newLayers[0]
        .getLatLngs()
        .map((latlng) => [latlng.lat, latlng.lng])
    );
    setLine([
      ...newLayers[0]
        .getLatLngs()
        .map((latlng) => [latlng.lat, latlng.lng]),
    ]);
  }



  return (
    <div style={{ minHeight: "500px" }}>
      <MapContainer
        style={{ minHeight: "500px" }}
        ref={mapRef}
        zoom={13}
        scrollWheelZoom={false}
        bounds={bounds}
        whenReady={(map) => {
          console.log("whenReady", line.length, mapRef.current);
          setLoadMap(true);
        }}
      >
        <TileLayer
          attribution=""
          url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        />
        <FeatureGroup ref={ref}>
          <EditControl
            draw={{
              polyline: false,
              polygon: false,
              rectangle: false,
              circle: false,
              marker: false,
              circlemarker: false,
            }}
            onEdited={updateLayers}
            edit={{
              remove: false,
            }}
          />

          <Polyline positions={line} />
        </FeatureGroup>
        <>
          <Marker
            position={line[0]}
            title="Inicio"
            icon={new L.Icon.Default({ className: "start" })}
          />
          <Marker
            position={line[line.length - 1]}
            title="Final"
            icon={new L.Icon.Default({ className: "end" })}
          />
          { item && (
          <Marker
            position={[item.lat, item.lng]}
            title={item.name ?? 'selección'}
            icon={new L.Icon.Default({ className: "selected" })}
          />
          )}
          {geofences.map((geo, index) => generateArea(geo, index))}
        </>
      </MapContainer>
      <div className="text-center mt-2">
        <Button color="primary" onClick={save} disabled={loading}>
          {loading && <Spinner size="sm"></Spinner>}{" "}
          <i className="fa fa-save"></i> Guardar
        </Button>
      </div>
    </div>
  );
};

export default EditMap;
